import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import Auth from '@aws-amplify/auth';
import { Amplify, Hub } from '@aws-amplify/core';
import Cookies from 'js-cookie';
import { AppName, createLogger } from '../logging';
const logger = createLogger(AppName.Common, 'auth');
export const initAmplify = options => {
  const {
    cookies: {
      domain,
      path
    },
    oauth,
    onCustomOAuthState,
    ...amplifyOptions
  } = options;
  const oauthConfig = (oauth === null || oauth === void 0 ? void 0 : oauth.domain) ? {
    oauth: {
      domain: oauth.domain,
      scope: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: oauth.redirectSignIn || window.location.origin,
      redirectSignOut: oauth.redirectSignOut || window.location.origin,
      responseType: 'code'
    }
  } : {};
  Hub.listen('auth', function () {
    var _ref = _asyncToGenerator(function* (data) {
      const tokenKey = 'token';
      logger.log(`Handling auth event: ${data.payload.event}`);

      const setTokenCookie = function () {
        var _ref2 = _asyncToGenerator(function* () {
          const currentSession = yield Auth.currentSession();
          const idToken = currentSession.getIdToken();
          const expirationTimeStamp = idToken.getExpiration();
          const expirationDate = new Date(expirationTimeStamp * 1000);
          const token = idToken.getJwtToken();
          Cookies.set(tokenKey, token, {
            domain,
            expires: expirationDate,
            path: path || '/customer/document/',
            sameSite: 'strict',
            secure: window.location.protocol === 'https:'
          });
        });

        return function setTokenCookie() {
          return _ref2.apply(this, arguments);
        };
      }();

      const removeTokenCookie = () => {
        Cookies.remove(tokenKey);
      };

      switch (data.payload.event) {
        case 'configured':
          try {
            yield setTokenCookie();
          } catch {}

          break;

        case 'signIn':
        case 'signUp':
        case 'tokenRefresh':
          try {
            yield setTokenCookie();
          } catch (error) {
            logger.raise(error);
            removeTokenCookie();
          }

          break;

        case 'signOut':
          removeTokenCookie();
          break;

        case 'customOAuthState':
          if (onCustomOAuthState) {
            onCustomOAuthState(data.payload.data);
          }

          break;
      }
    });

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
  Amplify.configure({ ...amplifyOptions,
    ...oauthConfig
  });
};